<template>
  <v-navigation-drawer v-model="isShow"
                       fixed
                       app>
    <v-list>
      <v-list-group>
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>fa fa-briefcase</v-icon>
          </v-list-item-icon>
          <v-list-item-title>产品管理</v-list-item-title>
        </template>

        <v-list-item class="title-second"
                     @click="changeRoute('ProductList', 2)">
          <v-list-item-icon>
            <v-icon>fa fa-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="[{'active': navigationValue == 2}, 'item-title' ]">信息管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="title-second"
                     @click="changeRoute('ProductType', 4)">
          <v-list-item-icon>
            <v-icon>fa fa-sitemap</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="[{'active': navigationValue == 4}, 'item-title' ]">类型管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list-group>

      <v-list-group>
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>fa fa-newspaper</v-icon>
          </v-list-item-icon>
          <v-list-item-title>新闻管理</v-list-item-title>
        </template>

        <v-list-item class="title-second"
                     @click="changeRoute('NewsList', 3)">
          <v-list-item-icon>
            <v-icon>fa fa-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="[{'active': navigationValue == 3}, 'item-title' ]">信息管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list-group>

      <v-list-group>
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>fa fa-users</v-icon>
          </v-list-item-icon>
          <v-list-item-title>员工管理</v-list-item-title>
        </template>

        <v-list-item class="title-second"
                     @click="changeRoute('StaffInfo', 6)">
          <v-list-item-icon>
            <v-icon>fa fa-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="[{'active': navigationValue == 6}, 'item-title' ]">信息管理</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-group>
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon>fa fa-file</v-icon>
          </v-list-item-icon>
          <v-list-item-title>浏览信息</v-list-item-title>
        </template>

        <v-list-item class="title-second"
                     @click="changeRoute('ViewedList', 1)">
          <v-list-item-icon>
            <v-icon>fa fa-tasks</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="[{'active': navigationValue == 1}, 'item-title' ]">信息一览</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="title-second"
                     @click="changeRoute('ViewedCount', 5)">
          <v-list-item-icon>
            <v-icon>fa fa-book</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="[{'active': navigationValue == 5}, 'item-title' ]">信息统计</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list-group>

      <v-row class="rows title-first"
             @click="logout">
        <v-icon>fa fa-reply</v-icon>
        <v-flex :class="[{'active': navigationValue == 8}, 'item-title' ]">退出登录</v-flex>
      </v-row>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    toggle: {
      type: Boolean,
      default: false
    },
    navigationValue: {
      type: Number,
      default: 1
    }
  },

  data () {
    return {
      isShow: false
    }
  },
  watch: {
    toggle () {
      this.isShow = this.toggle
    }
  },
  mounted () {
    this.init();
  },

  methods: {
    init () {
      this.$nextTick(() => {
        this.isShow = this.toggle;
      })
    },
    //跳转界面
    changeRoute (routeName, value) {
      this.$emit("updateNavigationValue", value);
      return this.$router.push({ name: routeName });

    },

    // 退出事件
    logout () {
      this.$emit("comfirm", '确定退出系统?', {})
    },
  },
}
</script>

<style scoped>
.rows {
  margin: 0;
  justify-items: center;
  align-items: center;
}
.toolbar {
  font-weight: bold;
  font-size: 18px;
}

.toolbar .text {
  padding-left: 15px;
  color: white;
  text-decoration: none;
}

.item-title {
  font-size: 17px;
  font-weight: 500;
}
.item-sub-title {
  font-size: 15px;
  font-weight: 500;
}

.active {
  font-weight: bolder;
  color: cornflowerblue;
}
.title-first {
  height: 40px;
}
.title-first .v-icon {
  margin: 0 18px 0 3px;
  width: 50px;
}
.title-second * {
  font-size: 15px !important;
  margin-left: 10px;
}
</style>
